import { CheckBadgeIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Actions as PAYPERIOD_ACTIONS } from "@/redux/actions/payPeriodActions";
import { Actions as PAYROLL_ACTIONS } from "@/redux/actions/payrollActions";
import ListView, { Row } from "@/components/common/custom-lists/ListView";
import Modal from "@/components/common/Modal";

const HMRCErrorsModal = ({ isOpen, closeModal, errors, generateRTISubmissions, periodId, period }) => {
	return (
		<Modal
			title="HMRC Errors"
			status={isOpen}
			close={closeModal}
			width="75%"
		>
			<div className="block-content">
				<ListView
					{...{
						title: "HMRC Errors",
						columns: [{ hidden: true }, "Source", "Type", "Reason", { hidden: true }],
						items: errors?.map((error) => {
							return (
								<Row
									actionColumns={[0]}
									columns={[
										" ",
										error?.RaisedBy,
										error?.Type[0].charAt(0).toUpperCase() + error?.Type[0].slice(1),
										error?.Text,
										" ",
									]}
								/>
							);
						}),
					}}
				/>
				<div className="col-xs-12 p-0 mb-5">
					<button
						className="btn btn-success pull-right"
						onClick={() => {
							closeModal();
							generateRTISubmissions(periodId);
						}}
					>
						<CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Resend</div>
					</button>
					<button
						className="btn btn-danger pull-right mr-3"
						type="button"
						onClick={closeModal}
					>
						Close
					</button>
				</div>
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		isOpen: state.payrollHistory?.hmrcErrorsModal?.open,
		errors: state.payrollHistory?.hmrcErrorsModal?.period?.FPSErrors,
		periodId: state.payrollHistory?.hmrcErrorsModal?.period?.id,
		period: state.payrollHistory?.hmrcErrorsModal?.period,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		closeModal: () => {
			dispatch(PAYPERIOD_ACTIONS.setHMRCErrorsModal({ open: false }));
		},
		generateRTISubmissions: (periodId) => dispatch(PAYROLL_ACTIONS.generateRTISubmissions(periodId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(HMRCErrorsModal);
